import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import userTokenService from 'common/services/security/userTokenService';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import './ShowForRole.scss';

const ShowForRole = ({
  projectId,
  roles,
  children,
  restrictedForRoleElement = <div data-testid="restricted-for-role" />,
}) => {
  const [hasProjectRole, setHasProjectRole] = useState(false);
  const [hasProjectRoleBeenFetched, setHasProjectRoleBeenFetched] =
    useState(false);

  /**
   * TODO: jm - In the future, we'd ideally want to store user roles in redux
   * If we do that, we won't have to touch different tokens in session storage
   * based on the user current user role selected in Global Toggle.
   */
  const userRole = useSelector(getUserRole);

  useEffect(() => {
    let isMounted = true;
    const projectRole = userTokenService.getProjectTokenProperty(
      projectId,
      'role',
      userRole
    );

    const hasRole = roles.includes(projectRole);

    if (isMounted) {
      setHasProjectRoleBeenFetched(true);
      setHasProjectRole(hasRole);
    }

    return () => {
      isMounted = false;
    };
  }, [projectId, roles, userRole]);

  if (hasProjectRoleBeenFetched) {
    if (hasProjectRole) {
      return children;
    }
    return (
      <div className="restrictedForRoleElement">{restrictedForRoleElement}</div>
    );
  }
  return null;
};

ShowForRole.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ShowForRole;
